module.exports = __webpack_public_path__ + "files/a3de2170e4e9df77161ea5d3f31b2668.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.5.0
 ** module id = 839
 ** module chunks = 0
 **/